const UserFunction = Object.freeze({
  RESPONSABLE: 'responsable',
  DECLARANT: 'declarant',
  MASTER_OF_CEREMONIES: 'master_ceremony',
  RESPONSABLE_CEREMONY: 'responsable_ceremony',
  ADVISOR: 'advisor',
  SPEAKER: 'ceremony_speaker',
  DRIVER: 'driver',
  CARRIER: 'porter',
  THANATO: 'thanato'
})

export default UserFunction